export default function displayDeliveryPeriods() {
  const deliveries = document.querySelectorAll('.js-pickup-availability-delivery');

  if (!deliveries.length) {
    return;
  }

  const productSkus = [];

  deliveries.forEach((delivery) => {
    const productSku = delivery.getAttribute('data-product-sku');
    if (!productSku) {
      return;
    }
    productSkus.push(productSku);
  });

  fetch('https://lab9.apps.esign.eu/products/inventory', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ product_skus: productSkus }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Er is een probleem opgetreden bij het ophalen van de inventaris.');
      }
      return response.json();
    })
    .then((inventory) => {
      deliveries.forEach((delivery) => {
        delivery.innerHTML = '';

        const productSku = delivery.getAttribute('data-product-sku');
        const relevantInventory = inventory.find(
          (item) =>
            item.inventoryLevels.edges.length > 0 &&
            item.inventoryLevels.edges[0].node.item.sku === productSku,
        );

        if (!relevantInventory) {
          const deliveryText = `: ${window.deliveryOptionsStrings.notInStock}`;
          const deliveryHtml = `<span>${deliveryText}</span>`;
          const deliveryNode = new DOMParser().parseFromString(deliveryHtml, 'text/html').body
            .childNodes[0];
          delivery.append(deliveryNode);
          return;
        }

        let deliveryText = '';
        relevantInventory.inventoryLevels.edges.forEach((inventoryLevel) => {
          const inventoryLocation = inventoryLevel.node.location.name;
          const inventoryQuantity = inventoryLevel.node.quantities[0].quantity;

          if (inventoryLocation === 'WEBSHOP' && inventoryQuantity > 0) {
            deliveryText = `: ${window.deliveryOptionsStrings.workingDaysShort}`;
          } else if (inventoryQuantity > 0) {
            if (deliveryText !== `: ${window.deliveryOptionsStrings.workingDaysShort}`) {
              deliveryText = `: ${window.deliveryOptionsStrings.workingDaysLong}`;
            }
          }
        });

        if (!deliveryText) {
          deliveryText = `: ${window.deliveryOptionsStrings.notInStock}`;
        }

        const deliveryHtml = `<span>${deliveryText}</span>`;
        const deliveryNode = new DOMParser().parseFromString(deliveryHtml, 'text/html').body
          .childNodes[0];
        delivery.append(deliveryNode);
      });
    })
    .catch((error) => {
      console.error('Er is een fout opgetreden:', error);
    });
}

window.displayDeliveryPeriods = displayDeliveryPeriods;
